import enCampaignsShortcuts from '@components/campaigns-shortcuts/locales/en.json'
import esCampaignsShortcuts from '@components/campaigns-shortcuts/locales/es.json'
import ptCampaignsShortcuts from '@components/campaigns-shortcuts/locales/pt.json'
import enCardInfluencerLife from '@components/card-influencer-life/locales/en.json'
import esCardInfluencerLife from '@components/card-influencer-life/locales/es.json'
import ptCardInfluencerLife from '@components/card-influencer-life/locales/pt.json'
import enHeader from '@components/header/locales/en.json'
import esHeader from '@components/header/locales/es.json'
import ptHeader from '@components/header/locales/pt.json'
import enModalNotification from '@components/modal-notification/locales/en.json'
import esModalNotification from '@components/modal-notification/locales/es.json'
import ptModalNotification from '@components/modal-notification/locales/pt.json'
import enDefaultLayout from '@layouts/default/locales/en.json'
import esDefaultLayout from '@layouts/default/locales/es.json'
import ptDefaultLayout from '@layouts/default/locales/pt.json'
import enHomePage from '@pages/home/locales/en.json'
import esHomePage from '@pages/home/locales/es.json'
import ptHomePage from '@pages/home/locales/pt.json'
import enRegisterComponent from '@src/components/register-completeness/locales/en.json'
import esRegisterComponent from '@src/components/register-completeness/locales/es.json'
import ptRegisterComponent from '@src/components/register-completeness/locales/pt.json'
import enHelpPage from '@src/pages/help/locales/en.json'
import esHelpPage from '@src/pages/help/locales/es.json'
import ptHelpPage from '@src/pages/help/locales/pt.json'
import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import enGlobalMain from './assets/locales/en.json'
import esGlobalMain from './assets/locales/es.json'
import ptGlobalMain from './assets/locales/pt.json'
import enBoxReachComponent from './components/box-reach-home/locales/en.json'
import esBoxReachComponent from './components/box-reach-home/locales/es.json'
import ptBoxReachComponent from './components/box-reach-home/locales/pt.json'
import ptBannerCreatorsInsights from './components/creators-insights/banner/locales/pt.json'
import esBannerCreatorsInsights from './components/creators-insights/banner/locales/es.json'
import enBannerCreatorsInsights from './components/creators-insights/banner/locales/en.json'

export const defaultNS = 'template'
export const resources = {
  en: {
    globalMain: enGlobalMain,
    helpPage: enHelpPage,
    defaultLayout: enDefaultLayout,
    modalNotification: enModalNotification,
    registerComponent: enRegisterComponent,
    campaignsShortcuts: enCampaignsShortcuts,
    header: enHeader,
    boxReachComponent: enBoxReachComponent,
    homePage: enHomePage,
    cardInfluencerLife: enCardInfluencerLife,
    bannerCreatorsInsights: enBannerCreatorsInsights,
  },
  pt: {
    globalMain: ptGlobalMain,
    helpPage: ptHelpPage,
    defaultLayout: ptDefaultLayout,
    modalNotification: ptModalNotification,
    registerComponent: ptRegisterComponent,
    campaignsShortcuts: ptCampaignsShortcuts,
    header: ptHeader,
    boxReachComponent: ptBoxReachComponent,
    homePage: ptHomePage,
    cardInfluencerLife: ptCardInfluencerLife,
    bannerCreatorsInsights: ptBannerCreatorsInsights,
  },
  es: {
    globalMain: esGlobalMain,
    helpPage: esHelpPage,
    defaultLayout: esDefaultLayout,
    modalNotification: esModalNotification,
    registerComponent: esRegisterComponent,
    campaignsShortcuts: esCampaignsShortcuts,
    header: esHeader,
    boxReachComponent: esBoxReachComponent,
    homePage: esHomePage,
    cardInfluencerLife: esCardInfluencerLife,
    bannerCreatorsInsights: esBannerCreatorsInsights,
  },
} as const

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    defaultNS,
    ns: [
      'globalMain',
      'helpPage',
      'defaultLayout',
      'modalNotification',
      'registerComponent',
      'socialItem',
      'campaignsShortcuts',
      'header',
      'boxReachComponent',
      'sectionList',
      'homePage',
      'cardInfluencerLife',
      'bannerCreatorsInsights',
    ],
    load: 'all',
    supportedLngs: ['en', 'es', 'pt'],
    lng: navigator.language?.split('-')[0] || 'en',
    fallbackLng: 'en',
    debug: false,
    cache: {
      enabled: false,
    },
    resources,
  })

export default i18n
